import { render, staticRenderFns } from "./DeudaView.vue?vue&type=template&id=0706baae&scoped=true"
import script from "./DeudaView.vue?vue&type=script&lang=js"
export * from "./DeudaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0706baae",
  null
  
)

export default component.exports